document.addEventListener("DOMContentLoaded", function () {

    if (window.innerWidth > 767) return;

    const gallery = document.querySelector(".product_detail_slider");
    const info = document.querySelector(".product__info-container");

    if (!gallery || !info) return;

    // Find all product-info blocks
    const blocks = info.querySelectorAll(".product-info");

    let ratingBlock = null;

    blocks.forEach(block => {
        // Judge.me
        if (block.querySelector(".jdgm-widget")) {
            ratingBlock = block;
        }

        // Shopify Product Reviews
        if (block.querySelector(".spr-badge")) {
            ratingBlock = block;
        }

        // Loox
        if (block.querySelector(".loox-rating")) {
            ratingBlock = block;
        }
    });

    if (ratingBlock) {
        ratingBlock.after(gallery);
    }

});